export enum COLORS {
    BgMain = '#FFFFFF',
    BgSurface = '#F5F8FB',
    BgSubstrate = '#F9FCFD',
    BgLight = '#FAFAFA',
    BgSecondary = '#EEEEEF',
    BgError = '#FDEEEE',
    BgSuccess = '#EEFFF5',

    ButtonAccent = '#FF312C',
    ButtonPrimary = '#1E1F33',
    ButtonSecondary = '#E0EBF0',
    ButtonWhite = '#FFFFFF',

    TextPrimary = '#181B21',
    TextSecondary = '#393C41',
    TextInfo = '#5C5E62',
    TextHint = '#74767A',
    TextDisabled = '#C5C6C7',
    TextWhite = '#FFFFFF',

    Success = '#69C48F',
    Error = '#FF7B7B',
    Logo = '#FF312C',
    Locked = '#FFB0B0',
    Link = '#518399',
    Outline_Dark = '#9BCDDD',
    Digital_Blue = '#75C1D9',
    Brand_Blue = '#AFDAE8',
    Disabled = '#BBCCD4',
    Outline_Light = '#E0EBF0',
    Control = '#181B21',
    GRAY_DARK = '#74767A',
    GRAY_LIGHT = '#C5C6C7',

    LabelsText_1 = '#10B278', // success
    LabelsText_2 = '#EE516E', // danger
    LabelsText_3 = '#E7910E', // warning
    LabelsText_4 = '#85558C', //
    LabelsText_5 = '#007AE5', // info
    LabelsText_6 = '#6176E6', //
    LabelsBg_1 = '#DBF5EB',
    LabelsBg_2 = '#FDE1E1',
    LabelsBg_3 = '#FFE9C8',
    LabelsBg_4 = '#E6D8E8',
    LabelsBg_5 = '#C6E1F9',
    LabelsBg_6 = '#DFE3FB',

    transparent = 'transparent',
}
